import { useEffect, useRef } from "react";
import { ListeningStatus, MAX_CONTINUOUS_IDLE_MINUTES , MAX_CONTINUOUS_LISTENING_MINUTES } from 'shared/config/constants';

const useListeningWatchdog = ({
  listeningStatus,
  onListeningExceeded,
  onIdleExceeded
}) => {
  const timeoutRef = useRef(null);
  const hasListenedRef = useRef(false);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    if (listeningStatus === ListeningStatus.Listening) {
      hasListenedRef.current = true;
      timeoutRef.current = setTimeout(() => {
        onListeningExceeded?.();
      }, MAX_CONTINUOUS_LISTENING_MINUTES * 60 * 1000);
    }

    if (listeningStatus === ListeningStatus.Idle && hasListenedRef.current) {
      timeoutRef.current = setTimeout(() => {
        onIdleExceeded?.();
        hasListenedRef.current = false;
      }, MAX_CONTINUOUS_IDLE_MINUTES * 60 * 1000);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [listeningStatus, onListeningExceeded, onIdleExceeded]);
};

export default useListeningWatchdog;